import { render } from "./PdfRejectModal.vue?vue&type=template&id=64ef98cf&scoped=true&ts=true"
import script from "./PdfRejectModal.vue?vue&type=script&lang=ts"
export * from "./PdfRejectModal.vue?vue&type=script&lang=ts"

import "./PdfRejectModal.vue?vue&type=style&index=0&id=64ef98cf&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ef98cf"]])

export default __exports__